import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";

const Navbar = (props) => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const [logo, setLogo] = useState("");

    const getlogo = async () => {
        try {
            const headerss = {
                accept: "*/*",
                "Access-Control-Allow-Credentials": "false",
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            };

            await axios({
                method: "get",
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss,
            }).then((res) => {
                setLogo(res.data[0]);
            });
        } catch (err) { }
    };

    useEffect(() => {
        getlogo();
    }, []);

    return (
        <nav
            className="navbar navbar-expand-sm bg-body-tertiary py-0"
            style={{ backgroundColor: "white", borderBottom: " solid #e9ecef" }}
        >
            <div
                className="container-fluid d-flex align-items-center justify-content-between"
                style={{ backgroundColor: "white", minHeight: 72 }}
            >
                <a className="navbar-brand d-flex align-items-center py-0" href="/">
                    <img
                        src={logo["photo"]}
                        alt="logo"
                        style={{ maxWidth: "220px", maxHeight: "72px" }}   // 🔥 80 -> 46
                        className="img-fluid"
                    />
                </a>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-0"></ul>

                    <div className="d-flex align-items-center">
                        <a
                            href="/profile"
                            className="d-flex align-items-center text-decoration-none"
                            style={{ gap: 10, color: "inherit" }}
                        >
                            <i
                                className="fa fa-user-circle"
                                style={{ fontSize: 36, lineHeight: 1 }}
                                aria-hidden="true"
                            />
                            <span style={{ lineHeight: 1.10 }}>
                                <strong>{user?.user?.["fullName"]}</strong>
                                <br />
                                {user?.role}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;